module.exports = __webpack_public_path__ + "img/wx.cb8122d0.png";